import React, { useCallback, useEffect, useState } from 'react';
import { notes } from '../services/api';
import DetailNote from './DetailNote';
import './Notes.css';
import { eur } from '../services/format';

const LIBELLES_STATUT = {
  soumise: 'Soumise',
  validee: 'Validée',
  refusee: 'Refusée',
  transmise: 'Transmise',
  remboursee: 'Remboursée',
};

function periodeLisible(p) {
  const [a, m] = String(p).split('-');
  const d = new Date(parseInt(a, 10), parseInt(m, 10) - 1, 1);
  return d.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' });
}

// Mes notes — même format que l'écran Validation : la liste, et le même
// aperçu de contrôle. Mobile : le détail prend l'écran ; bureau : maître-
// détail, liste à gauche, aperçu à droite.
function MesNotes() {
  const [liste, setListe] = useState(null);
  const [selection, setSelection] = useState(null); // id de note

  const charger = useCallback(() => {
    notes.mes().then((res) => setListe(res.data.notes)).catch(() => setListe([]));
  }, []);
  useEffect(() => { charger(); }, [charger]);

  if (liste === null) return null;

  return (
    <div className="nt-layout">
      <div className={`nt-pane-liste ${selection ? 'nt-cache-mobile' : ''}`}>
        <h2 className="nf-titre-page">Mes notes de frais</h2>
        {liste.length === 0 ? (
          <div className="nf-vide">
            <h2>Aucune note soumise</h2>
            <p>Vos dépenses en attente se soumettent en un clic depuis l'écran Dépenses.</p>
          </div>
        ) : (
          <ul className="nt-liste">
            {liste.map((n) => (
              <li key={n.id}>
                <button type="button"
                  className={`nt-carte ${selection === n.id ? 'nt-carte--active' : ''}`}
                  onClick={() => setSelection(n.id)}>
                  <span className="nt-carte-rangee">
                    <span className="nt-carte-gauche">
                      <span className="nt-carte-titre">
                        {n.dossier_libelle ? `📁 ${n.dossier_libelle}` : `Note de ${periodeLisible(n.periode)}`}
                      </span>
                      <span className="nt-carte-sous">
                        {n.nb_lignes} dépense{n.nb_lignes > 1 ? 's' : ''}
                        {n.soumise_le ? ` · soumise le ${new Date(n.soumise_le).toLocaleDateString('fr-FR')}` : ''}
                        {' '}· nº {n.id}
                      </span>
                      {n.statut === 'refusee' && n.motif_refus && (
                        <span className="nt-motif">Motif : {n.motif_refus}</span>
                      )}
                    </span>
                    <span className="nt-carte-cote">
                      <span className="nf-montant nt-carte-total">{eur(n.total_ttc)}</span>
                      <span className={`nf-statut nf-statut--${n.statut}`}>{LIBELLES_STATUT[n.statut] || n.statut}</span>
                    </span>
                  </span>
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>

      <div className={`nt-pane-detail ${selection ? '' : 'nt-cache-mobile'}`}>
        {selection ? (
          <DetailNote
            id={selection}
            integre
            onFermer={() => setSelection(null)}
            onRappelee={() => { setSelection(null); charger(); }}
          />
        ) : (
          <div className="nt-placeholder">
            <p>Sélectionnez une note à gauche pour la consulter.</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default MesNotes;
